import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function PasswordResetConfirm() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    if (pw !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    if (!token) {
      toast.error("Reset link is missing or invalid");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2200);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Reset failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="container-bsp h-16 flex items-center">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-[#1A1F3D] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#D4A853]" />
          </div>
          <span className="font-display text-xl text-[#1A1F3D]">BrandSnapPro™</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bsp-card p-8 md:p-10">
          {done ? (
            <div className="text-center" data-testid="reset-done">
              <CheckCircle2 className="w-10 h-10 text-[#D4A853] mx-auto" />
              <h1 className="font-display text-2xl text-[#1A1F3D] mt-3">Password updated</h1>
              <p className="text-[#52525b] mt-2">Redirecting you to login…</p>
            </div>
          ) : (
            <>
              <span className="eyebrow">Set a new password</span>
              <h1 className="font-display text-3xl text-[#1A1F3D] mt-3">Choose a new password</h1>
              <p className="text-[#52525b] mt-2">Make it at least 8 characters.</p>
              <form onSubmit={submit} className="mt-7 space-y-4" data-testid="reset-confirm-form">
                <div>
                  <label className="text-sm font-medium text-[#1A1F3D]">New password</label>
                  <input type="password" required minLength={8} className="bsp-input mt-1" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="new-pw" />
                </div>
                <div>
                  <label className="text-sm font-medium text-[#1A1F3D]">Confirm new password</label>
                  <input type="password" required minLength={8} className="bsp-input mt-1" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-pw" />
                </div>
                <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="reset-confirm-submit">
                  {submitting ? "Saving…" : "Set new password"}
                </button>
              </form>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
